import { datadogRum } from '@datadog/browser-rum';

import packageJson from '../../package.json';

import { getEnvVar } from './environmentVariables';

export const initDataDog = (): void => {
  const applicationId = getEnvVar('NEXT_PUBLIC_DATA_DOG_APPLICATION_ID');
  const clientToken = getEnvVar('NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN');

  if (!applicationId || !clientToken) {
    console.warn('Datadog initialization skipped: Missing application ID or client token.');
    return;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: getEnvVar('NEXT_PUBLIC_DATA_DOG_SITE'),
    service: 'backoffice',
    env: getEnvVar('NEXT_PUBLIC_STAGE'),
    version: packageJson.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    allowFallbackToLocalStorage: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
  });
};
